import { z } from 'zod'

export const healthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  /** API package version. */
  version: z.string(),
  /** Seconds since the API process started. */
  uptime: z.number(),
  database: z.object({
    connected: z.boolean(),
    /** Number of migrations recorded as applied. */
    appliedMigrations: z.number().int().nonnegative(),
    /** Tag of the most recent applied migration, if any. */
    latestMigration: z.string().nullable(),
  }),
  timestamp: z.iso.datetime(),
})

export type HealthResponse = z.infer<typeof healthResponseSchema>
